import OriginTree from './Tree';
import TreeNode from './TreeNode';
var Tree = OriginTree;
Tree.TreeNode = TreeNode;
export { TreeNode };
export default Tree;


//////////////////
// WEBPACK FOOTER
// ../~/_rc-tree@2.1.2@rc-tree/es/index.js
// module id = 1422
// module chunks = 0